var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDuelEmptyState = function SvgDuelEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 246,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.431 246c62.96 0 113.999-51.063 113.999-114.051 0-62.99-51.039-114.052-113.999-114.052-62.96 0-113.999 51.063-113.999 114.052C10.432 194.937 61.472 246 124.431 246Z",
    fill: "url(#duel-empty-state_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#duel-empty-state_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.945 218.802a7.48 7.48 0 0 1-2.58-.463 7.607 7.607 0 0 1-3.842-3.183 7.813 7.813 0 0 1-1.09-4.915l5.843-54.684h-44.69a7.493 7.493 0 0 1-3.914-1.099 7.658 7.658 0 0 1-2.796-2.992 7.816 7.816 0 0 1 .412-7.942l59.865-91.011a7.603 7.603 0 0 1 3.943-3.018 7.47 7.47 0 0 1 4.934.087 7.61 7.61 0 0 1 3.721 3.027 7.811 7.811 0 0 1 1.211 4.686l-5.842 55.069h44.69a7.492 7.492 0 0 1 3.913 1.099 7.656 7.656 0 0 1 2.797 2.992 7.816 7.816 0 0 1-.412 7.942l-59.865 91.011a7.636 7.636 0 0 1-2.733 2.496 7.495 7.495 0 0 1-3.565.898Z",
    fill: "url(#duel-empty-state_svg__c)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5 75.552a14.343 14.343 0 0 1-14.367 14.366H180.37a19.373 19.373 0 0 1-3.093-.256 18.047 18.047 0 0 1-11.104-6.614 18.063 18.063 0 0 1 1.56-24.093 18.042 18.042 0 0 1 11.864-5.126 25.428 25.428 0 0 1 11.036-11.754 25.414 25.414 0 0 1 30.228 4.604 25.444 25.444 0 0 1 7.04 14.507h.217a14.354 14.354 0 0 1 13.287 8.863 14.373 14.373 0 0 1 1.095 5.503Z",
    fill: "url(#duel-empty-state_svg__d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.063 47.06a10.823 10.823 0 0 0 10.825 10.83h35.94a13.583 13.583 0 0 0 9.46-3.905A13.595 13.595 0 0 0 57.4 30.72a19.138 19.138 0 0 0-31.026-5.354 19.158 19.158 0 0 0-5.317 10.885h-.162a10.823 10.823 0 0 0-7.652 3.162 10.833 10.833 0 0 0-3.181 7.645Z",
    fill: "url(#duel-empty-state_svg__e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 185.533a14.3 14.3 0 0 0 3.542 9.428 14.286 14.286 0 0 0 8.876 4.752 13.69 13.69 0 0 0 1.887.131h47.554a19.191 19.191 0 0 0 3.093-.255 17.974 17.974 0 0 0 11.134-6.566 17.993 17.993 0 0 0-1.564-24.082 17.974 17.974 0 0 0-11.89-5.069 25.328 25.328 0 0 0-10.992-11.695 25.312 25.312 0 0 0-30.094 4.583 25.337 25.337 0 0 0-7.017 14.438h-.224a14.294 14.294 0 0 0-10.124 4.2A14.309 14.309 0 0 0 .5 185.533Z",
    fill: "url(#duel-empty-state_svg__f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.705 106.456a1.655 1.655 0 0 1 2.051-2.003l8.197 2.305c1.226.345 1.62 1.889.708 2.779l-6.093 5.949a1.655 1.655 0 0 1-2.76-.775l-2.103-8.255ZM24.699 106.456a1.655 1.655 0 0 1 2.05-2.003l8.198 2.305a1.656 1.656 0 0 1 .708 2.779l-6.093 5.949a1.654 1.654 0 0 1-2.76-.775l-2.103-8.255ZM88.557 8.003c.489-2.028 3.372-2.028 3.862 0l1.623 6.727c.175.724.74 1.29 1.464 1.465l6.728 1.625c2.027.49 2.027 3.372 0 3.861l-6.728 1.625c-.724.175-1.29.74-1.464 1.465l-1.623 6.727c-.49 2.027-3.373 2.027-3.862 0l-1.623-6.727a1.987 1.987 0 0 0-1.465-1.465l-6.728-1.625c-2.026-.49-2.026-3.372 0-3.861l6.728-1.625a1.986 1.986 0 0 0 1.465-1.465l1.623-6.727Z",
    fill: "#A9E0D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.835 225.482a4.517 4.517 0 1 1-9.033 0 4.517 4.517 0 1 1 9.033 0Z",
    stroke: "#A9E0D4",
    strokeWidth: 2.483
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.583 188.226c.49-2.027 3.373-2.027 3.862 0l1.623 6.727c.175.725.741 1.29 1.465 1.465l6.728 1.625c2.027.489 2.027 3.372 0 3.862l-6.728 1.624a1.988 1.988 0 0 0-1.465 1.465l-1.623 6.728c-.489 2.027-3.372 2.027-3.862 0l-1.623-6.728a1.986 1.986 0 0 0-1.464-1.465l-6.728-1.624c-2.027-.49-2.027-3.373 0-3.862l6.728-1.625a1.984 1.984 0 0 0 1.464-1.465l1.623-6.727Z",
    fill: "#A9E0D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.79 159.65a4.518 4.518 0 0 1-4.516 4.519 4.518 4.518 0 0 1-4.517-4.519 4.518 4.518 0 1 1 9.033 0Z",
    stroke: "#5DC0AD",
    strokeOpacity: 0.4,
    strokeWidth: 2.483
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "duel-empty-state_svg__a",
    x1: 123.553,
    y1: -19.24,
    x2: 125.89,
    y2: 381.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "duel-empty-state_svg__c",
    x1: 122.698,
    y1: 49.118,
    x2: 122.698,
    y2: 218.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DC0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84E4D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "duel-empty-state_svg__d",
    x1: 227.28,
    y1: 111.863,
    x2: 187.358,
    y2: 39.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "duel-empty-state_svg__e",
    x1: 58.903,
    y1: 74.39,
    x2: 28.883,
    y2: 19.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "duel-empty-state_svg__f",
    x1: 65.301,
    y1: 221.707,
    x2: 25.549,
    y2: 149.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "duel-empty-state_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(31.648 41.406)",
    d: "M0 0h182.099v185.109H0z"
  })))));
};
export default SvgDuelEmptyState;